import fixturesActionTypes from "./fixtures.types";

export const fetchAllFixturesStart = ({ token } = {}) => ({
  type: fixturesActionTypes.FETCH_ALL_FIXTURES_START,
  payload: { token },
});

export const fetchAllFixturesSuccess = (fixtures) => ({
  type: fixturesActionTypes.FETCH_ALL_FIXTURES_SUCCESS,
  payload: fixtures,
});

export const fetchAllFixturesFailure = (error) => ({
  type: fixturesActionTypes.FETCH_ALL_FIXTURES_FAILURE,
  payload: error,
});

export const fetchUserFixturesStart = ({ token }) => ({
  type: fixturesActionTypes.FETCH_USER_FIXTURES_START,
  payload: { token },
});

export const fetchUserFixturesSuccess = (fixtures) => ({
  type: fixturesActionTypes.FETCH_USER_FIXTURES_SUCCESS,
  payload: fixtures,
});

export const fetchUserFixturesFailure = (error) => ({
  type: fixturesActionTypes.FETCH_USER_FIXTURES_FAILURE,
  payload: error,
});

export const fetchCreatorFixturesStart = ({ token, tournamentId } = {}) => ({
  type: fixturesActionTypes.FETCH_CREATOR_FIXTURES_START,
  payload: { token, tournamentId },
});

export const fetchCreatorFixturesSuccess = (fixtures) => ({
  type: fixturesActionTypes.FETCH_CREATOR_FIXTURES_SUCCESS,
  payload: fixtures,
});

export const fetchCreatorFixturesFailure = (error) => ({
  type: fixturesActionTypes.FETCH_CREATOR_FIXTURES_FAILURE,
  payload: error,
});

export const fetchTournamentFixturesStart = ({
  token,
  tournamentId,
  viewMode = "subscriber",
}) => ({
  type: fixturesActionTypes.FETCH_TOURNAMENT_FIXTURES_START,
  payload: { token, tournamentId, viewMode },
});

export const fetchTournamentFixturesSuccess = ({
  fixtures,
  tournamentId,
  viewMode,
}) => ({
  type: fixturesActionTypes.FETCH_TOURNAMENT_FIXTURES_SUCCESS,
  payload: { fixtures, tournamentId, viewMode },
});

export const fetchTournamentFixturesFailure = (error) => ({
  type: fixturesActionTypes.FETCH_TOURNAMENT_FIXTURES_FAILURE,
  payload: error,
});

export const clearTournamentFixtures = () => ({
  type: fixturesActionTypes.CLEAR_TOURNAMENT_FIXTURES,
});
